import { useCallback } from 'react'
import { NavigateOptions, To, useNavigate } from 'react-router-dom'

type AppNavigateFunction = (to: To, options?: NavigateOptions) => void

/**
 * @returns wrapped navigate function that sets replace: true
 * to avoid adding entries to the history stack.
 */
export const useAppNavigate = ():AppNavigateFunction => {
  const navigate = useNavigate()

  const appNavigate = useCallback((to: To, options?: NavigateOptions) => {
    navigate(to, { ...options, replace: true })
  }, [])

  return appNavigate
}